module.exports = __webpack_public_path__ + "static/media/Mobile-Banner-Account-Services.8e308583.jpg";